exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\nbody {\r\n  margin: 0;\n}\n#app {\r\n  width: 100%;\r\n  max-width: 1000px;\r\n  margin: 0 auto;\n}\n.box {\r\n  padding: 10px;\r\n  border: 1px solid #ddd;\r\n  -webkit-box-shadow: 1px 1px 5px rgba(0, 0, 0, 0.1);\r\n          box-shadow: 1px 1px 5px rgba(0, 0, 0, 0.1);\n}\n.textarea {\r\n  width: 100%;\r\n  border: 0;\r\n  outline: 0 none;\r\n  resize: none;\r\n  font-size: 14px;\r\n  line-height: 1.5;\r\n  font-family: Menlo, \"Ubuntu Mono\", Consolas, \"Courier New\", \"Microsoft Yahei\",\r\n    \"Hiragino Sans GB\", \"WenQuanYi Micro Hei\", sans-serif;\n}\n.p-40 {\r\n  padding: 40px;\n}\r\n", ""]);

// exports
